import React, { useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Select from 'react-select';
import useForm from 'react-hook-form';

import { Calendar as BigCalendar, momentLocalizer } from "react-big-calendar";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Slide from "@material-ui/core/Slide";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import Snackbar from "beaktShared/components/Snackbar/Snackbar.js";
import NovoAgendamento from "./NovoAgendamento";
import AgendamentoRecorrente from "./AgendamentoRecorrente";
import AgendamentoContrato from "./AgendamentoContrato";
import VisualizarAgendamento from "./VisualizarAgendamento";
import Datetime from "react-datetime";
import { makeStyles } from "@material-ui/core/styles";
import GridContainer from "beaktShared/components/Grid/GridContainer.js";
import GridItem from "beaktShared/components/Grid/GridItem.js";
import Card from "beaktShared/components/Card/Card.js";
import CardBody from "beaktShared/components/Card/CardBody.js";
import Checkbox from "@material-ui/core/Checkbox";
import styles from "assets/jss/material-dashboard-pro-react/views/agenda.js";
import stylesMaterial from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from "beaktShared/components/CustomButtons/Button.js";
import AddIcon from '@material-ui/icons/Add';
import DialogTitle from "@material-ui/core/DialogTitle";
import CardHeader from "beaktShared/components/Card/CardHeader.js";
import CardIcon from "beaktShared/components/Card/CardIcon.js";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import { ValidSelect } from "beaktShared/helpers/validselect";

// @material-ui/icons
import {
  Check,
  Search,
} from '@material-ui/icons';

//services
import { setSessionCookie, getSessionCookie, setTokenCookie } from "beaktShared/services/session";
import { UseGetApiSimple, UsePostApi, UsePostApiLogin, UsePutApi } from "beaktShared/services/crudeApiService";
import { SessionContext } from "beaktShared/services/session";
import { convertDate, formateDate, getLocale, getStringFormatDate} from "beaktShared/helpers/masks";
import moment from "moment";
import 'moment/locale/pt-br'
import 'moment/locale/en-gb'

import queryString from 'query-string';
import Hidden from "@material-ui/core/Hidden";
import { isTemplateMiddle } from 'typescript';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="down" ref={ref} {...props} />;
});

const useStyles = makeStyles(styles);
const useStylesMaterial = makeStyles(stylesMaterial);
const localizer = momentLocalizer(moment);

export default function Agenda({ location }) {
    const { t } = useTranslation();
    const classesMaterial = useStylesMaterial();
    const { register, errors, setValue, clearError } = useForm({ mode: "onBlur" });

    const [loading,setloading] = React.useState(false);
    const [showfilterlateral, setshowfilterlateral] = React.useState(true);    
    const [session, setSession] = React.useState(useContext(SessionContext));
    
    useEffect(() => {
        const locale = getLocale();
        if (locale === 'pt-br') {
            moment.locale('pt-br');
        } else {
            moment.locale('en-gb');
        }

        verifyAcess();
        validateUrlParams().then((result) => {
            setloading(true);
            if (!result) return;

            const s = getSessionCookie();
            setSession(s);

            loadProfissionais(s);
            LoadSelectServico(s);

            LoadHoraMinMax(s).then(() => {
                loadAgendamentos(new Date());
            });

            PermissoesAcesso(s);
            handleSetup(false);
        });
    }, []);
    
    //metodo para verificar se o usuario logado possui permissão para visualizar o setup da agenda
    const [exibeSetup, setexibeSetup] = React.useState(false);
    const [showBtnAgendamentoRecorrente, setShowBtnAgendamentoRecorrente] = React.useState(false);
    const [showBotoes, setShowBotoes] = React.useState(false);
    const PermissoesAcesso = (s) => {
        var sessionUse = session;
        if(sessionUse === null)
            sessionUse = s;

        if (s.estabelecimentoId > 0)
        {
            setShowBtnAgendamentoRecorrente(true);
            setShowBotoes(true);
        }
        
        UseGetApiSimple("usuarios/getpermissoes/" + sessionUse.estabelecimentoId + "/" + session.id).then(result => {      
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                return false; 
            }  
            result.data.map(item => {
                if (item.path == "setupAgenda" && s.estabelecimentoId > 0) {
                    setexibeSetup(true);
                }
            });
        });

    };

    const [errorParams,seterrorParams] = React.useState({
        showerror:false,
        message: ''
    });

    const [obsNovoAgendamento, setobsNovoAgendamento] = React.useState("");
    const [selectedServico, setselectedServico] = React.useState(null);

    const validateUrlParams = () =>{

      return new Promise(function (retornaresult){
        //http://localhost:3000/externalagenda?token=E2$15%TD3A67&cnpj=09017515000179&prf=6&descespecialidade=salao&descservico=corte%20de%20cabelo&durservico=40
        seterrorParams({showerror:false,message: ''});

        if(!location)   
        {     
            retornaresult(true);
            return;
        }

        let urlp = location.pathname;
        if(!(urlp === '/externalagenda'))
        {
            // Não valida os parametros da URL
            retornaresult(true);
            return;
        }
        
        setshowfilterlateral(false);
        let urls = location.search;
        let params = queryString.parse(urls);
                   
        if(!params.token)
        {
            seterrorParams({showerror:true,message: 'token é obrigatorio'});
            retornaresult(false);
            return;
        }

        if(!params.cnpj)
        {
            seterrorParams({showerror:true,message: 'cnpj é obrigatorio'});
            retornaresult(false);
            return;
        }
        
        if(!params.prf)
        {
            seterrorParams({showerror:true,message: 'profissional é obrigatorio'});
            retornaresult(false);
            return;
        }

        if(!params.descespecialidade)
        {
            seterrorParams({showerror:true,message: 'Descrição da Especialidade é obrigatorio'});
            retornaresult(false);
            return;
        }

        if(!params.descservico)
        {
            seterrorParams({showerror:true,message: 'Descrição do Serviço é obrigatorio'});
            retornaresult(false);
            return;
        }
        
        if(!params.durservico)
        {
            seterrorParams({showerror:true,message: 'Duracao do Serviço é obrigatorio'});
            retornaresult(false);
            return;
        } 
        
        if(!(params.token === "E2$15%TD3A67"))
        {
            seterrorParams({showerror:true,message: 'token inválido'});
            retornaresult(false);
            return;
        } 

        if (params.obs){
            setobsNovoAgendamento(params.obs);
        }
        
        UsePostApiLogin("usuarios/generatetokenanonymous?tokenfixed=" + params.token, "").then(result => {
            var token = {
                accessToken: result.data.accessToken,
                expiration: result.data.expiration        
            }

            setTokenCookie(token);      

            var objSendSetupUrl = {
                cnpj: params.cnpj,
                profissionalId:params.prf,
                descespecialidade: params.descespecialidade,
                descservico: params.descservico,
                durservico: params.durservico
            }
    
            let endPoint = 'agendamentos/setupexternalagenda';
            setloading(true);
            UsePostApi(endPoint, objSendSetupUrl).then(result=>{
    
                if(result.status !== 200)
                {                                  
                    showNotification(result.message,'danger');
                    seterrorParams({showerror:true,message: 'Error setup agenda'});       
                    setloading(false);
                    retornaresult(false);
                    return;
                } 
                     
                setSessionCookie(result.data);           
                setselectedServico(params.descservico);
    
                setloading(false);
                retornaresult(true);   
                return;
            });
        });         

      });
    };
       
    const classes = useStyles();
    const [notification, setNotification] = React.useState(false);
    const [colorNotification, setColorNotification] = React.useState('info');    
    const [mensagemNotification, setMensagemNotification] = React.useState(false);
    const showNotification = (mensagem,color) => { 
        setMensagemNotification(mensagem);
        setColorNotification(color);      
        setNotification(true);
        setTimeout(function() {
            setNotification(false);
        }, 6000);       
    };

    const [missingConfigExpediente, setmissingConfigExpediente] = React.useState(false);
    
    const [showModalAdd, setshowModalAdd] = React.useState(false);
    const [showModalEdit, setshowModalEdit] = React.useState(false);
    const [showModalAgendamentoRecorrente, setShowModalAgendamentoRecorrente] = React.useState(false);
    const [ShowModalAgendamentoContrato, setShowModalAgendamentoContrato] = React.useState(false);

    const [dateselected,setdateselected] = React.useState(new Date());
    const [viewselected,setviewselected] = React.useState('day');

    var dtin = new Date();
    var dted = new Date();
    dtin.setHours(0,0,0); 
    dted.setHours(23,0,0);             

    const [dtmin,setdtmin] = React.useState(dtin);
    const [dtmax,setdtmax] = React.useState(dted);

    const LoadHoraMinMax = (s) =>{

        var sessionUse = session;
        if(sessionUse === null)
            sessionUse = s; 

        return new Promise(function (retornaresult) {
            let estabelecimentoSelecionado = sessionUse.estabelecimentoId || estabelecimento;
            const endPoint = "agendamentos/horaminmax/" + estabelecimentoSelecionado
            UseGetApiSimple(endPoint,0).then(result=>{    

                if(result.status !== 200)
                {                                     
                    showNotification(result.message,'danger');
                    return retornaresult(false);
                    return false; 
                }  
                
                if(result.data.horaMin === null)
                {
                    setmissingConfigExpediente(true);
                    return retornaresult(false);
                    return false;
                }
                
                setmissingConfigExpediente(false);
                var HoraMinS = result.data.horaMin.split(":");
                var HoraMin = parseInt(HoraMinS[0]);
                var MinutMin = parseInt(HoraMinS[1]);

                var HoraMaxS = result.data.horaMax.split(":");
                var HoraMax = parseInt(HoraMaxS[0]);
                var MinutMax = parseInt(HoraMaxS[1]);
                
                const dtmin2 = new Date(); 
                const dtmax2 = new Date();
                dtmin2.setHours(HoraMin,MinutMin,0); 
                dtmax2.setHours(HoraMax,MinutMax,0);             
                setdtmin(dtmin2);
                setdtmax(dtmax2);

                return retornaresult(true);
                return true;                
            }); 
        });
    };

    //Dados Setup
    const [showModalSetup, setshowModalSetup] = React.useState(false);
    const [SetupDados, setSetupDados] = React.useState([]);
    const [PermissoesSetup, setPermissoesSetup] = React.useState([])
    const [showBtnAgendamentoContrato, setshowBtnAgendamentoContrato] = React.useState(false);

    const handleSetup = (showModal) =>{

        var sessionUse = session;

        const endPoint = "agendamentos/getSetupEstabelecimento/"+sessionUse.estabelecimentoId
        UseGetApiSimple(endPoint,0).then(result=>{    

            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                return false; 
            }  

            let lstSetup = [];

            result.data.map(item => lstSetup.push({
                setupEstabelecimentoId: item.setupEstabelecimentoId,
                estabelecimentoId: item.estabelecimentoId,
                setupId: item.setupId,
                ativo: item.ativo,
                descricao: item.setup.descricao,
                codigo: item.setup.codigo
            }));
            
            setSetupDados(lstSetup);

            if(showModal)
                setshowModalSetup(true);

            setexibeSetup(false);

            if (lstSetup.length > 0)
            {
                setexibeSetup(true);
                let AgendamentoContrato = lstSetup.filter(f => f.codigo == 'SETUP01')[0];
                
                if(AgendamentoContrato.ativo === true){
                    setshowBtnAgendamentoContrato(true);
                }
                else{
                    setshowBtnAgendamentoContrato(false);
                }
            }

            return true;                
        }); 
    };

    const handleCheckSetups = (e,setupEstabelecimentoId) =>{

        let permissao = SetupDados.filter(f => f.setupEstabelecimentoId == setupEstabelecimentoId)[0];
	
        permissao.ativo = e.target.checked;
        
        let lista_permissoes = [];
        SetupDados.map(m => {
            if (m.setupEstabelecimentoId == setupEstabelecimentoId)
                lista_permissoes.push(permissao);
            else
                lista_permissoes.push(m);
        });
        
        setPermissoesSetup(lista_permissoes);

    };

    const handleSaveSetups = () =>{
        
        let endPoint = 'agendamentos/updatesetupagenda';
            setloading(true);

            UsePostApi(endPoint, PermissoesSetup).then(result=>{
    
                if(result.status !== 200)
                {                                  
                    showNotification(result.message.message,'danger');
                    seterrorParams({showerror:true,message: 'Error setup agenda'});       
                    setloading(false);
                    return;
                }  
                showNotification(result.data.message,'success');
                handleSetup(false);
                setloading(false);

                setTimeout(() => {
                    setshowModalSetup(false);
                }, 1000);

            return true;                
        });
     
    };

    const [eventos,seteventos] = React.useState([]);
    const [eventosIndisponiveisC,seteventosIndisponiveisC] = React.useState([]);
    const [eventIndisp,seteventIndisp] = React.useState([]);
    const [agendamentos,setagendamentos] = React.useState([]);
    const profObj = [{
        id: 0,
        title: '--'
    }];

    const [servicos,setservicos] = React.useState([]);
    const [profissionaisLoading, setprofissionaisLoading] = React.useState(false);
    const [profissionais,setprofissionais] = React.useState(profObj);
    const [profissionaisResources,setprofissionaisResources] = React.useState(profObj);
   
    const eventColors = event => {
        var backgroundColor = "event-";
        event.color
            ? (backgroundColor = backgroundColor + event.color)
            : (backgroundColor = backgroundColor + "default");
        return {
            className: backgroundColor
        };       
    };

    const tratarAgendamento = (item) =>{

        var agDate = new Date(item.data);
               
        let horaInicio = item.horaInicio.split(":");
        let Hinicio = parseInt(horaInicio[0]);
        let Minicio = parseInt(horaInicio[1]);
        
        let horaFim = item.horaFim.split(":");
        let Hfim = parseInt(horaFim[0]);
        let Mfim = parseInt(horaFim[1]);

        var dataIni = new Date(agDate.getFullYear(),agDate.getMonth(),agDate.getDate(),Hinicio,Minicio);
        var dataFim = new Date(agDate.getFullYear(),agDate.getMonth(),agDate.getDate(),Hfim,Mfim);

        var color = "";
        if(item.statusEvento === 0)
        {//Agendamento
            color = verifyColorByStatus(item.statusAgendamento);            
        }
        if(item.statusEvento === 1)
        {// Almoço
            color = "blocked"; 
        }
        var title = "";
        if(item.nomeCliente)
            title = t('label.client')+": "+item.nomeCliente + " | "+t('label.service')+": "+item.descricaoServico;
        if (item.obs !== null)
            title = title + (title === "" ? "" : " | ")+ item.obs;        

        var ag = {
            id: item.agendamentoId,
            title: title,
            allDay: false,
            resourceId: item.profissionalId, //id do profissional para agrupamento
            start: dataIni,
            end: dataFim,
            color: color,
            status: item.statusEvento,
            statusAgendamento: item.statusAgendamento,
            nomeCliente: item.nomeCliente,
            nomeProfissional: item.nomeProfissional,
            descricaoServico: item.descricaoServico,
            obs:item.obs,
            observacaoAcao: item.observacaoAcao,
            celularcliente: item.celularCliente
        }
        return ag;
    };

    const verifyColorByStatus = (status) =>{
        if(status === 0)
            return "azure";
        else if(status === 1)
            return "green";
        else if(status ===2)
            return "red";
        else if(status ===4)
            return "orange";
        else if(status ===5)
            return "purple";
    };

    const loadAgendamentos = (_date) =>{         
        
        const dataFormatada = (new Intl.DateTimeFormat('en-US', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(_date));

        var s = getSessionCookie();
        let obj = {
            estabelecimentoId: s.estabelecimentoId || estabelecimento,
            dataAgenda:dataFormatada
        }

        setloading(true);      
        const endPoint = "agendamentos/eventos/";
        UsePostApi(endPoint,obj).then(result=>{    
            setloading(false);   
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                return false; 
            }
            
            let lstAgendamentos = [];

           var eventAgendamentos = result.data.filter(obj => {
                return obj.statusEvento === 0;
            });                  

            eventAgendamentos.map(item =>{
               var ag = tratarAgendamento(item);
               lstAgendamentos.push(ag);
            })
            setagendamentos(lstAgendamentos);
            seteventos(lstAgendamentos);

            var eventIndisponivel = result.data.filter(obj => {
                return obj.statusEvento !== 0;
            });
            seteventIndisp(eventIndisponivel);
            loadEventIndisp(_date,_date,eventIndisponivel,lstAgendamentos);
            return true;                
        });  
    };

    const loadEventIndisp = (dateIni,dateEnd, eventosindisponiveisH,agendamentosH) =>{
        //getDay() is an integer corresponding to the day of the week: 0 for Sunday, 1 for Monday, 2 for Tuesday, and so on
        if(!dateIni)
        {
            seteventos(agendamentosH);
            return;
        }

        if(eventosindisponiveisH.length <1)
            return;         
            
        var start = new Date(dateIni);
        var end = new Date(dateEnd);
        
        let eventosIndisponiveis = [];

        var loop = new Date(start);
        
        while(loop <= end) {
            var dayofWeek = loop.getDay();
            var eventbyDayWeek = eventosindisponiveisH.filter(obj => {
                return (obj.diaSemana === dayofWeek || (obj.data !== null && formateDate(obj.data) === formateDate(loop)));
            });
                        
            if(!eventbyDayWeek)                                        
                return;

            eventbyDayWeek.map(item =>{
                var ag = tratarDadosIndisponiveis(item,loop)
                eventosIndisponiveis.push(ag);                
            });
            
            var newDate = loop.setDate(loop.getDate() + 1);
            loop = new Date(newDate);
        }

        seteventosIndisponiveisC(eventosIndisponiveis);
        let eventall = [...agendamentosH,...eventosIndisponiveis]
        seteventos(eventall);
    };
    
    const tratarDadosIndisponiveis = (item, date) =>{        
        var dataIni = "";
        var dataFim = "";
        if(item.statusEvento ===1)
        {//HorarioAlmoço
            var horaInicio = item.horaInicio.split(":");
            var Hinicio = parseInt(horaInicio[0]);
            var Minicio = parseInt(horaInicio[1]);
            
            var horaFim = item.horaFim.split(":");
            var Hfim = parseInt(horaFim[0]);
            var Mfim = parseInt(horaFim[1]);

            dataIni = new Date(date.getFullYear(),date.getMonth(),date.getDate(),Hinicio,Minicio);
            dataFim = new Date(date.getFullYear(),date.getMonth(),date.getDate(),Hfim,Mfim);
        }
        else if(item.statusEvento ===3)
        {//HorarioIndisponivel
            let horaInicio = item.horaInicio.split(":");
            let Hinicio = parseInt(horaInicio[0]);
            let Minicio = parseInt(horaInicio[1]);
            
            let horaFim = item.horaFim.split(":");
            let Hfim = parseInt(horaFim[0]);
            let Mfim = parseInt(horaFim[1]);

            dataIni = new Date(date.getFullYear(),date.getMonth(),date.getDate(),Hinicio,Minicio);
            dataFim = new Date(date.getFullYear(),date.getMonth(),date.getDate(),Hfim,Mfim);
        }
        else
        {                
            dataIni = new Date(date.getFullYear(),date.getMonth(),date.getDate(),dtmin.getHours(),dtmin.getMinutes());
            dataFim = new Date(date.getFullYear(),date.getMonth(),date.getDate(),dtmax.getHours(),dtmax.getMinutes());
        }
       
        
        var color = "blocked"; 

        var title = item.obs;

        var ag = {
            id: item.agendamentoId,
            title: title,
            allDay: false,
            resourceId: item.profissionalId, //id do profissional para agrupamento
            start: dataIni,
            end: dataFim,
            color: color,
            status: item.statusEvento
        }
        return ag;
    };

    const loadProfissionais = (s) => {
        var sessionUse = session;
        if(sessionUse === null)
            sessionUse = s;
        
        let estabelecimentoSelecionado = sessionUse.estabelecimentoId || estabelecimento;
        
        setprofissionaisLoading(true);
        const endPoint = "profissionais/agenda/" + estabelecimentoSelecionado
        UseGetApiSimple(endPoint,0).then(result=>{       
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                setprofissionaisLoading(false);
                return false; 
            }             

            let lstProfissionais = [];
            result.data.map(item =>{

                var p = {
                    id: item.profissionalId,
                    title: item.nome,
                    especialidade: item.profissionalEspecialidades,
                    servicos: item.profissionalServicos
                  }                
                
                if(session && session.tipoPerfil===2)
                {// Perfil Profissional só vê a agenda dele
                    if(item.usuarioId === session.id)                    
                        lstProfissionais.push(p);                                    
                }
                else if(session && session.tipoPerfil!==2)
                {   
                    lstProfissionais.push(p);                                    
                }
                else
                {                                      
                    lstProfissionais.push(p);   
                }
                
            });

            setprofissionais(lstProfissionais);
            setprofissionaisResources(lstProfissionais);   
            
            if(location)
            {
                let urls = location.search;
                let params = queryString.parse(urls);               
                if(params.prf)
                    preselectProf(lstProfissionais,params.prf) 
            }  
               
            setprofissionaisLoading(false);         
            return true;                
        }); 
        return true;  
    };

    const preselectProf =(lstProfissionais,idProf) =>{
        let listFiltered = lstProfissionais.filter(obj => {
            return obj.id === parseInt(idProf);
        });
        setprofissionaisResources(listFiltered);        
    };

    const LoadSelectServico = (s) => {  
        var sessionUse = session;
        if(sessionUse === null)
            sessionUse = s;
        
        let estabelecimentoSelecionado = sessionUse.estabelecimentoId || estabelecimento;
        
        const endPoint = "servicos/ativos/byestabelecimento/" + estabelecimentoSelecionado;
        UseGetApiSimple(endPoint,0).then(result=>{       
            if(result.status !== 200)
            {                                     
                showNotification(result.message,'danger');
                return false; 
            }      
                 
            setservicos(result.data);
            return true;                
        });  
    };

    const messages = {
        allDay: t('agenda.all_day'),
        previous: '<',
        next: '>',
        today: t('agenda.today'),
        month: t('label.month'),
        week: t('agenda.week'),
        day: t('agenda.day'),
        agenda: t('sidebar.agenda'),
        date: t('label.date'),
        time: t('label.time'),
        event: t('agenda.scheduling'),
        showMore: total => t('label.display') + total
    };

    const closemodalAdd =()=>{
        setshowModalAdd(false);
    };

    const closemodalEdit =()=>{
        setshowModalEdit(false);
        var s = getSessionCookie();
    };

    const handleChangeCheckProfissionais = (e,id,title) =>{

        if(e.target.checked)
        {
          //adiciona profissional
            var p = {
                id: id,
                title: title
            }
           const newlist = [...profissionaisResources, p];
           setprofissionaisResources(newlist);  
        }
        else
        {
            //remove profissional
            let listFiltered = profissionaisResources.filter(obj => {
                return obj.id !== id;
            });
            setprofissionaisResources(listFiltered); 
        }
    };

    const [newevent,setnewevent] = React.useState({});
    useEffect(() => {

        if(newevent.data)
        {
            var ag = tratarAgendamento(newevent);
            const newlist = [...agendamentos, ag];         
            let eventall = [...newlist,...eventosIndisponiveisC]            
            seteventos(eventall);
            setagendamentos(newlist);

            var agDate = new Date(newevent.data);
            LoadCalendarbyDay(agDate,newlist);
        }
        
    }, [newevent]);

    const [editevent,seteditevent] = React.useState({});
    useEffect(() => {

        if(editevent.id)
        {
            let listFiltered = eventos.filter(obj => {
                return obj.id === editevent.id;
            });

            listFiltered = listFiltered[0];

            var color = verifyColorByStatus(editevent.statusAgendamento);
            listFiltered.color = color;
            listFiltered.statusAgendamento = editevent.statusAgendamento;

            if(editevent.statusAgendamento ===3)
            {
                var listFilteredRemove = agendamentos.filter(obj => {
                    return obj.id !== editevent.id;
                });
                setagendamentos(listFilteredRemove); 

                let eventall = [...listFilteredRemove,...eventosIndisponiveisC]
                seteventos(eventall);
            }
            else
            {
                const updateList = agendamentos.map(l => (l.id === editevent.id ? listFiltered : l));
                setagendamentos(updateList);

                let eventall = [...updateList,...eventosIndisponiveisC]
                seteventos(eventall);
            }            
        }
        
    }, [editevent]);

    const [viewCalendar,setviewCalendar] = React.useState('day');
    const handleRangeChange = (date,view) => {
        let viewP = viewCalendar;
        
        var dateIni = new Date()
        var dateEnd = new Date()

        if(view)
        {
            if(view !== viewP)
                viewP = view;    
        }    

        if(viewP === 'day')
        {
            dateIni = new Date(date[0])
            dateEnd = new Date(date[0])
        }
        else if(viewP === 'week')
        {
            dateIni = new Date(date[0])
            dateEnd = new Date(date[6])
        }
        else if(viewP === 'month')
        {
            dateIni = null
            dateEnd = null
        }

        setviewCalendar(viewP);
        loadEventIndisp(dateIni,dateEnd,eventIndisp,agendamentos);
    };
    
    const handleChangePicker = (date) =>{                
        setdateselected(date);
        LoadCalendarbyDay(date,null);
    };

    const LoadCalendarbyDay = (date, agendamentosT) =>{       

        var d1 = date.getDate();
        var d2 = dateselected.getDate();
        var m1 = date.getMonth();
        var m2 = dateselected.getMonth();
        var y1 = date.getFullYear();
        var y2 = dateselected.getFullYear();

        if(d1===d2 && m1===m2 && y1===y2)
            return;
        
        loadAgendamentos(date)
        setdateselected(date);
        setviewselected('day');
        setviewCalendar('day');

        if(!agendamentosT)
            loadEventIndisp(date,date,eventIndisp,agendamentos);
        else
            loadEventIndisp(date,date,eventIndisp,agendamentosT);
    };

    const [selectedEvent,setselectedEvent] = React.useState({});
    const handleSelectEvent = event => {
        if(event.id === 0)
            return; 
        
        const endPoint = "agendamentos/" + event.id
        UseGetApiSimple(endPoint, 0).then(result => {
          if (result.status !== 200) {
              showNotification(result.message, 'danger');
              return false;
            }
          event.observacaoAcao = result.data.observacaoAcao;

        });
        
        setTimeout(function () {
            setselectedEvent(event);
            setshowModalEdit(true);
        }, 400);
    };

    const [selectedSlot,setselectedSlot] = React.useState({});
    const handleAddEvent = slotInfo => {
        if (session.estabelecimentoId !== 0)
        {
            if(viewselected === 'month')
            {   
                LoadCalendarbyDay(slotInfo.start,null);
                return;
            }
            
            setselectedSlot(slotInfo);
            setshowModalAdd(true);
        }
    };

    const handleModalAgendamentoRecorrente = () => {
        setShowModalAgendamentoRecorrente(true);
    };

    const handleModalAgendamentoContrato = () => {
        setShowModalAgendamentoContrato(true);
    };

    const handleReturnModalAgendamentoRecorrente = () => {
        loadAgendamentos(new Date());
    };

    const handleReturnModalAgendamentoContrato = () => {
        showNotification("Agendamento Gravado com sucesso!",'success');  
        loadAgendamentos(new Date());
    };

    const [showSelectEstabelecimentos, setshowSelectEstabelecimentos] = React.useState(false);
    const [isLoadingEstabelecimento, setisLoadingEstabelecimento] = React.useState(false);
    const [estabelecimentos, setestabelecimentos] = React.useState([]);
    const [estabelecimento, setestabelecimento] = React.useState(0);

    const verifyAcess = () => {
        if (session.estabelecimentoId === 0) //Acessando tela pelo modulo matriz
        {
            setshowSelectEstabelecimentos(true);
            LoadEstabelecimentos();
        }
        else
        {
            setshowSelectEstabelecimentos(false);
            setestabelecimentos([session.estabelecimentoId]);
        }
    };

    const LoadEstabelecimentos = () => {
        setisLoadingEstabelecimento(true);
        const endPoint = "estabelecimentos/ativos/byfranquia/"+session.franquiaId;
        UseGetApiSimple(endPoint, 0).then(result => {
        if (result.status !== 200) {
            showNotification(result.message, 'error')
            setisLoadingEstabelecimento(false);
            return false;
        }

        setisLoadingEstabelecimento(false);
        setestabelecimentos(result.data);
        return true;
        });
    };

    const handleEstabelecimentoChange = event => {
        let value = event
        setestabelecimento(value);
        setValue("estabelecimento", value);
        if (value !== "")
            clearError("estabelecimento");
    };

    const handleClickPesquisa = () => {
        if (estabelecimento === 0)
        {
            showNotification(t('label.select_an_establishment'), 'danger')
            return false;
        } 
        else 
        {
            var s = getSessionCookie();

            loadProfissionais(s);
            LoadSelectServico(s);
            
            LoadHoraMinMax(s).then(() => {
                loadAgendamentos(new Date());
            });
        }
    };

    return (
        <div>
            <Snackbar
                place="tr"
                color={colorNotification}
                message={mensagemNotification}
                open={notification}
                closeNotification={() => setNotification(false)}
                close
            />

            {
                showSelectEstabelecimentos &&
                <div style={{paddingBottom: '25px'}}>
                    <Card>
                        <CardHeader color="primary" icon>
                            <CardIcon color="primary">
                                <Search/>
                            </CardIcon>
                            <h4 className={classes.cardIconTitle}>{t('agenda.search_establishment')}</h4>
                        </CardHeader>
                        <CardBody style={{ overflow: "visible", position: "relative", zIndex: 1 }}>
                            <GridContainer>
                                <GridItem xs={12} sm={10} md={10}>                
                                    <FormControl fullWidth className={classes.formControl}>
                                    <label className={errors.estabelecimento ? "select__label select__label_error" : "select__label"}>{t('label.establishment')+" *"} </label>
                                    <Select
                                        classNamePrefix="select"
                                        styles={{
                                            ...ValidSelect(errors.estabelecimentos ? true : false),
                                            menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                        }}
                                        isSearchable={true}
                                        isLoading={isLoadingEstabelecimento}
                                        name="estabelecimento"
                                        placeholder="Selecione..."
                                        options={estabelecimentos}
                                        value={estabelecimentos.filter(({ estabelecimentoId }) => estabelecimentoId === estabelecimento)}
                                        getOptionLabel={({ descricao }) => descricao}
                                        getOptionValue={({ estabelecimentoId }) => estabelecimentoId}
                                        onChange={(value) => handleEstabelecimentoChange(value.estabelecimentoId !== null ? value.estabelecimentoId : "")}
                                        ref={() => register({ name: "estabelecimento" })
                                        }
                                    />
                                    {errors.estabelecimento &&
                                    <FormHelperText>
                                        <span className="obg"> {t('label.select_an_establishment')} </span>
                                    </FormHelperText>}
                                    </FormControl>                    
                                </GridItem>
                                <GridItem xs={12} sm={6} md={2}>
                                    <Button round color="primary"
                                        onClick={e => { handleClickPesquisa() }}>
                                        {t('label.search')}
                                    </Button>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </div>
            }

            <GridContainer>  
                <GridItem xs={12} sm={12} md={3}>
                <Hidden smDown implementation="css">
                 {showfilterlateral &&
                    <Card className={classes.cardAgenda}> 
                        <Datetime
                        locale={getLocale()}
                        dateFormat={getStringFormatDate()}
                        className="datetimeInline"
                        timeFormat={false}
                        open={true}
                        defaultValue={dateselected}
                        value={dateselected}
                        onChange={date => { handleChangePicker(date._d) }}
                        />
                    </Card>
                }
                {
                    showBtnAgendamentoRecorrente &&
                    <Button 
                        fullWidth 
                        type="button" 
                        onClick={() => handleModalAgendamentoRecorrente()} 
                        color="primary" 
                        className={classes.updateProfileButton}>
                        <AddIcon className={classes.icons} /> {t('agenda.recurring_scheduling')}
                    </Button>
                }
                {
                    showBtnAgendamentoContrato &&
                    <Button fullWidth type="button" onClick={() => handleModalAgendamentoContrato()} color="primary" className={classes.updateProfileButton}>
                    <AddIcon className={classes.icons} /> {t('agenda.contract_scheduling')}
                    </Button>
                }
                {
                    showfilterlateral &&
                    <Card>
                        <CardBody>
                            <h4 className={classes.cardIconTitle}>
                                {t('sidebar.professional')}
                            </h4>  
                            
                            <div className="sizeBoxFilter">
                            {profissionaisLoading && <div className="loadingitemVenda">
                                <CircularProgress size={20}  />
                            </div>}
                            {!profissionaisLoading && <>
                            {profissionais.map(item => (   
                                <div key={item.id} className="checkboxmi">  
                                    <Checkbox
                                        tabIndex={-1}     
                                        onChange={e=>{handleChangeCheckProfissionais(e,item.id,item.title)}}
                                        defaultChecked="true"                                           
                                        checkedIcon={<Check className={classesMaterial.checkedIcon} />}
                                        icon={<Check className={classesMaterial.uncheckedIcon} />}
                                        classes={{ checked: classesMaterial.checked }}                    
                                        name="profissional"                                                   
                                    /> 
                                    <label>{item.title}</label> 
                                </div>  
                            ))}
                            </>
                            }
                            </div>
                        </CardBody>
                    </Card>
                }
                </Hidden>
                </GridItem>
                <GridItem xs={12} sm={12} md={showfilterlateral ? 9 : 12 } style={{ zIndex: 0 }}>
                    {exibeSetup &&
                        <div>
                         <Button 
                            variant="secondary" 
                            size="sm" 
                            type="button" 
                            onClick={() => handleSetup(true)}>
                             {t('agenda.setup')}
                         </Button>
                        </div>
                    }
                    <div className={classes.boxLegenda} style={{
                        top: showfilterlateral ? '25px' : '20px',
                        right: showfilterlateral ? '70px' : '170px',
                        }}>   
                        {t('agenda.legend')}
                        <div className={classes.boxLegendaDetail} >
                            <div className={classes.boxLegendaDetailTitle} >
                                <b>{t('agenda.scheduling')}:</b>
                           </div>
                            <div className={classes.boxLegendaDetailTitle}>
                                <div className={classes.itemLegenda + " " + classes.itemLPendente}></div>
                                <span>{t('agenda.pending')}</span>
                           </div>
                            <div className={classes.boxLegendaDetailTitle}>
                                <div className={classes.itemLegenda + " " + classes.itemLConfirmado}></div>
                                <span>{t('agenda.confirmed')}</span>
                           </div>
                            <div className={classes.boxLegendaDetailTitle}>
                                <div className={classes.itemLegenda + " " + classes.itemLCancelado}></div>
                                <span>{t('agenda.canceled')}</span>
                           </div>
                            <div className={classes.boxLegendaDetailTitle}>
                                <div className={classes.itemLegenda + " " + classes.itemLCompareceu}></div>
                                <span>{t('agenda.showed_up')}</span>
                           </div>
                            <div className={classes.boxLegendaDetailTitle}>
                                <div className={classes.itemLegenda + " " + classes.itemLFaltou}></div>
                                <span>{t('agenda.missed')}</span>
                           </div>
                        </div>
                    </div>
                    <Card className={classes.cardAgenda}>
                        
                        {
                            loading &&
                            <div className="carregando">{t('label.loading')}...</div>
                        }
                        { 
                            missingConfigExpediente && 
                             <div className="carregando">
                                <div style={{ maxWidth: '85%', textAlign: 'center', margin: '0 auto'}}>
                                {   
                                    session.estabelecimentoId !== 0
                                    ? t('agenda.message_configure_agenda')
                                    : ''
                                }
                                </div>
                            </div>
                        }
                        {
                            errorParams.showerror && 
                            <div className="carregando2">{errorParams.message}</div>
                        }
                       
                        <CardBody calendar>
                            <BigCalendar    
                                popup                            
                                localizer={localizer}
                                events={eventos}
                                resources = {profissionaisResources}
                                selectable
                                defaultView="day"
                                view={viewselected}
                                onView={view => { setviewselected(view) }}
                                timeslots={4}
                                step={15}
                                date={dateselected}
                                onNavigate={date => { handleChangePicker(date) }}
                                onSelectEvent={event => handleSelectEvent(event)}
                                onSelectSlot={slotInfo => handleAddEvent(slotInfo)}
                                eventPropGetter={eventColors}
                                startAccessor="start"
                                endAccessor="end"                                
                                views={['day']}                                
                                messages = {messages}                               
                                min = {dtmin}
                                max = {dtmax}                                          
                                onRangeChange={handleRangeChange}        
                            />
                        </CardBody>
                        
                    </Card>
                </GridItem>
            </GridContainer>
            <Dialog
                classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal + ' ' + classes.modalLarge
                }}
                open={showModalAdd}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setshowModalAdd(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
            >                
                    <NovoAgendamento 
                        prof={profissionais} 
                        serv={servicos} 
                        selectedSlot={selectedSlot} 
                        setnewevent={setnewevent} 
                        closemodalAdd={closemodalAdd} 
                        selectedServico={selectedServico} 
                        obs={obsNovoAgendamento} 
                    />
            </Dialog>
            <Dialog
                classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal 
                }}
                open={showModalEdit}
                onBackdropClick="false"
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setshowModalEdit(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
            >
                <VisualizarAgendamento 
                    prof={profissionais} 
                    serv={servicos} 
                    selectedEvent={selectedEvent} 
                    seteditevent={seteditevent} 
                    closemodalEdit={closemodalEdit} 
                    mostraBotoes={showBotoes}
                />
            </Dialog>

            <Dialog
                classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal + ' ' + classes.modalLarge
                }}
                open={showModalAgendamentoRecorrente}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setShowModalAgendamentoRecorrente(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
            >
                <AgendamentoRecorrente prof={profissionais} serv={servicos} callback={handleReturnModalAgendamentoRecorrente} closemodal={() => setShowModalAgendamentoRecorrente(false)} selectedServico={selectedServico} showmodal={showModalAgendamentoRecorrente} />
                
            </Dialog>

            <Dialog
                classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal + ' ' + classes.modalLarge
                }}
                fullWidth
                maxWidth="lg"
                open={ShowModalAgendamentoContrato}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setShowModalAgendamentoContrato(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
            >
                <AgendamentoContrato callback={handleReturnModalAgendamentoContrato} closemodal={() => setShowModalAgendamentoContrato(false)} showmodal={ShowModalAgendamentoContrato} />
                
            </Dialog>
            <Dialog
                classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal + ' ' + classes.modalLarge
                }}
                open={showModalSetup}
                TransitionComponent={Transition}
                keepMounted
                onClose={() => setshowModalSetup(false)}
                aria-labelledby="classic-modal-slide-title"
                aria-describedby="classic-modal-slide-description"
            >   
            <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{background:'#5c4477'}}
                >
                  
                <h4 className={classes.modalTitle + " mb-3"} style={{color:'white', textAlign: 'center', fontSize: '20px'}}>{t('agenda.setup_schedule')}</h4>
                </DialogTitle>
                <GridContainer Style="width: 100% !important"> 
                    <GridItem xs={12} sm={12} md={12}> 
                        {SetupDados.map(item => (   
                            <div key={item.setupEstabelecimentoId} className="checkboxmi mt-4" style={{textAlign:'center'}}>
                                <div className="row">
                                    <div className="col-8"> 
                                        <h4 style={{marginTop:'5px',textAlign:'center'}}>{item.descricao}</h4>
                                        {
                                            item.setupId === 3 ? (
                                            <i>(Se habilitado, haverá uma tolerância de 30 minutos)</i>
                                            ) : null
                                        }
                                    </div>
                                    <div className="col-4"> 
                                        <label>{'Ativo ?'}</label>
                                        <Checkbox
                                            tabIndex={-1}
                                            onChange={e=>{handleCheckSetups(e,item.setupEstabelecimentoId)}}     
                                            defaultChecked={item.ativo}                                      
                                            checkedIcon={<Check className={classesMaterial.checkedIcon} />}
                                            icon={<Check className={classesMaterial.uncheckedIcon} />}
                                            classes={{ checked: classesMaterial.checked }}                    
                                            name="status"    
                                        /> 
                                    </div>
                                </div>
                            </div>  
                        ))}
                         <div style={{textAlign:'center'}} className="mt-4 mb-4">
                        <Button variant="primary"  size="md" type="button" color="primary" className={classes.updateProfileButton} onClick={() => handleSaveSetups()}>
                        {t('button.to_save')}
                        </Button>
                    </div>
                    </GridItem>
                </GridContainer>                
            </Dialog>
        </div>
    );
}
